/// <amd-module name="Tfs/Platform/ErrorHandling" />
import * as React from "react";
import * as Resources from "Tfs/Platform/Resources";
import { Components, VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { Link } from "VSSUI/Link";

interface ITfsErrorHandlerProps {
    /**
     * Called to reload the component tree that triggered this error.
     */
    reloadComponent: () => void;
    error: Error;
    errorInfo: React.ErrorInfo;
}

class TfsErrorHandler extends VssComponent<ITfsErrorHandlerProps, { hideInfo: boolean }> {
    constructor(props: ITfsErrorHandlerProps) {
        super(props);
        this.state = { hideInfo: true };
    }

    public render() {
        return (
            <div className="flex flex-column tfs-unhandled-error">
                <div className="tfs-unhandled-error--title">{Resources.UnhandledErrorTitle}</div>
                <div>{Resources.UnhandledErrorMessage}</div>
                <div className="tfs-unhandled-error--buttons flex flex-noshrink justify-start">
                    <Button
                        primary={true}
                        onClick={() => {
                            window.location.reload();
                        }}
                    >
                        {Resources.RefreshPageText}
                    </Button>
                    <Button
                        onClick={() => {
                            this.props.reloadComponent();
                        }}
                    >
                        {Resources.ReloadComponentText}
                    </Button>
                </div>
                <div className="tfs-unhandled-error--moreInfo">
                    {this.state.hideInfo ? (
                        <Link
                            onClick={e => {
                                this.setState({ hideInfo: false });
                                e.preventDefault();
                            }}
                        >
                            {Resources.ShowMoreInfoText}
                        </Link>
                    ) : (
                        <div>
                            <div className="tfs-unhandled-error--title">
                                {Resources.Error}: {this.props.error.message}
                            </div>
                            <div className="tfs-unhandled-error--stack">
                                <div className="tfs-unhandled-error--title">{Resources.Stack}</div>
                                {this.props.errorInfo.componentStack.trim()}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

Components.add("tfs.page-error-handler", TfsErrorHandler);
